import {
  DELETE_INTEGRATION,
  REQUEST_INTEGRATIONS_OVERVIEW,
  SAVE_INTEGRATION,
} from "../../utils/constants";

export const requestIntegrationsOverview = () => ({
  type: REQUEST_INTEGRATIONS_OVERVIEW,
});

export const saveIntegration = (payload) => ({
  type: SAVE_INTEGRATION,
  payload,
});

export const deleteIntegration = (payload) => ({
  type: DELETE_INTEGRATION,
  payload,
});

export const actions = {
  requestIntegrationsOverview,
  saveIntegration,
  deleteIntegration,
};

